// Admin gallery API helpers.

import { getToken, clearToken } from './adminApi';

const BASE = process.env.REACT_APP_BACKEND_URL;

async function _handle(res) {
  if (res.status === 401) { clearToken(); throw Object.assign(new Error('Unauthorized'), { status: 401 }); }
  if (!res.ok) {
    let detail = 'Request failed';
    try { const b = await res.json(); if (b?.detail) detail = typeof b.detail === 'string' ? b.detail : JSON.stringify(b.detail); } catch (_) {}
    throw Object.assign(new Error(detail), { status: res.status });
  }
  return res.json();
}

export async function listGallery(params = {}) {
  const q = new URLSearchParams();
  if (params.kind) q.set('kind', params.kind);
  if (params.category) q.set('category', params.category);
  return _handle(await fetch(`${BASE}/api/gallery?${q}`));
}

export async function uploadGalleryPhoto(file, { title = '', category = 'campus' } = {}) {
  const fd = new FormData();
  fd.append('file', file);
  const q = new URLSearchParams({ title, category });
  return _handle(await fetch(`${BASE}/api/admin/gallery/photo?${q}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${getToken()}` },
    body: fd,
  }));
}

export async function addGalleryVideo({ title, youtube_id, category = 'campus', poster }) {
  return _handle(await fetch(`${BASE}/api/admin/gallery/video`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${getToken()}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ title, youtube_id, category, poster }),
  }));
}

export async function deleteGalleryItem(id) {
  return _handle(await fetch(`${BASE}/api/admin/gallery/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${getToken()}` },
  }));
}
